import { Issues as IssuesLegacy } from '@shared/issues-legacy';
import { Issues as IssuesV01 } from '@shared/issues-v0-1';
import { Issues as IssuesV10 } from '@shared/issues-v1-0';
import { Issues as IssuesV11 } from '@shared/issues-v1-1';
import { SharedComponentVersion, VersionOption } from '../types';

export const ISSUES_COMPONENT_CATALOG: VersionOption[] = [
  {
    value: 'legacy',
    label: 'v0.1.0 - Legacy Package',
    component: IssuesLegacy,
    metadata: {
      version: '0.1.0 (Legacy)',
    },
  },
  {
    value: '0.1',
    label: 'v0.1.0',
    component: IssuesV01,
    metadata: {
      version: '0.1.0',
    },
  },
  {
    value: '1.0',
    label: 'v1.0.0',
    component: IssuesV10,
    metadata: {
      version: '1.0.0',
    },
  },
  {
    value: '1.1',
    label: 'v1.1.0',
    component: IssuesV11,
    metadata: {
      version: '1.1.0',
    },
  },
  {
    value: '2.0',
    label: 'v2.0.0 - (MUI v6 Required)',
    component: null,
    metadata: {
      version: '2.0.0',
      incompatible: true,
      incompatibilityReason:
        'This version requires @mui/material v6.x, but the current application is using @mui/material v5.x. Please upgrade MUI to v6 before using this version.',
    },
  },
  {
    value: '2.1',
    label: 'v2.1.0 - (MUI v6 Required)',
    component: null,
    metadata: {
      version: '2.1.0',
      incompatible: true,
      incompatibilityReason:
        'This version requires @mui/material v6.x, but the current application is using @mui/material v5.x. Please upgrade MUI to v6 before using this version.',
    },
  },
];

export const DEFAULT_VERSION: SharedComponentVersion = 'legacy';
